<template>
  <div>
    <home-h5 v-if="isMobile"></home-h5>
    <div v-else>
      <home-pc></home-pc>
    </div>
  </div>
</template>

<script>
import HomePc from './HomePc.vue'
import HomeH5 from './HomeH5.vue'

export default {
  name: 'Index',
  components: {
    HomePc,
    HomeH5
  },
  data() {
    return {
      isMobile: true, // 是否是移动端
      isAndroid: navigator.userAgent.match(/(Android);?[\s\/]+([\d.]+)?/),
      randomCount: 1024
    }
  },
  created() {
    this.isMobilePlat()
  },
  destroyed() {
    // window.removeEventListener('beforeunload', (e) => this.beforeunloadFn(e))
    // window.removeEventListener('pagehide', (e) => this.pagehideFn(e))
  },
  methods: {
    /**判断是否是移动端 */
    isMobilePlat() {
      const width = document.body.clientWidth
      if (width <= 768) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
      console.log('this.isMobile', this.isMobile)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/keyframes.less';
.page {
  position: relative;
  width: 100vw;
  height: 100vh;
}
/* PC端 */
@media screen and (min-width: 769px) {
  @import '../assets/css/pc.less';
}

/* 移动端  */
@media screen and (max-width: 769px) {
  @import '../assets/css/m.less';
}
</style>
